import { ReactComponent } from "./arrow-drop-down-fill.svg";

const ArrowDropDownFillIcon = () => <ReactComponent />;

export default ArrowDropDownFillIcon;
